/**
 * Parses a number or numeric string. Returns NaN for null, undefined, blank
 * and non-numeric input, where `Number()` would turn null and blank into 0.
 */
export function parseNumeric(
  value: number | string | null | undefined,
): number {
  if (value == null || (typeof value === 'string' && !value.trim())) {
    return NaN;
  }

  return Number(value);
}
